module.exports = __webpack_public_path__ + "static/img/geothermal-generator_256.9a81c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geothermal-generator_256.png
// module id = f6tN
// module chunks = 0